// extracted by mini-css-extract-plugin
module.exports = {"sps":"SpsProvider_sps__gtmZj","selected":"SpsProvider_selected__GOr2w","error":"SpsProvider_error__8nWiA"};